<template>
  <v-app>
    <app-header />
    <v-content>
    <app-bread v-if="isLogged" />
    <v-alert v-if="getFeedback" color="red">{{getFeedback}}</v-alert>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
  import Header from './components/header/header.vue'
  import Bread from './components/elements/Bread.vue'
  import {mapGetters} from 'vuex'
  
  /* eslint-disable */ 

  export default {
    name: 'App',
    computed: 
        mapGetters([
                    'getFeedback',
                    'isLogged'
                    ])
    ,  
    components: {
      'app-header': Header,
      'app-bread': Bread
    },
    created() {
      this.$store.dispatch('tryAutologin')
    }
  }
</script>

<style>
 a{
  text-decoration: none;
}
</style>